import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { string, func, object } from "prop-types";
import { push } from "react-router-redux";
import OrderConfirmationImg from "resources/images/order-confirmation.png";
import { trackPageViewed } from "utils/trackingFunctions";

const ConfirmationPage = ({ dispatch, userData, userStatusBeforeCheckout }) => {
  /* ----------- Event Handlers ------------ */
  useEffect(() => {
    trackPageViewed(
      userData.userAccountId,
      userData.companyAccountId,
      "Confirmation page"
    );
  }, []);

  const handleGoToDashboard = () => {
    dispatch(push("/dashboard"));
  };

  const confirmationVerbiage =
    userStatusBeforeCheckout === "free_trial"
      ? `Your talent success platform is ready to help you achieve your goals.
        Let's get started!`
      : `Your subscription has been successfully renewed.`;

  return (
    <div className="page-wrapper">
      <div className="mb-4">
        <img
          src={OrderConfirmationImg}
          alt="Order Confirmation"
          style={{ width: "200px", height: "auto" }}
        />
      </div>
      <div>
        <h4 className="font-weight-bold mb-3">Your order is confirmed!</h4>
        <div>{confirmationVerbiage}</div>
      </div>
      <Button
        onClick={handleGoToDashboard}
        id="goToDashboardFromConfirmationPage"
        variant="primary"
      >
        Go to Dashboard
      </Button>
    </div>
  );
};

ConfirmationPage.propTypes = {
  dispatch: func.isRequired,
  userData: object.isRequired,
  userStatusBeforeCheckout: string.isRequired,
};

export default ConfirmationPage;
